export const defaultProducto = () => {
    return {
        activo: 1,
        verificado: 0,
        nombre: '',
        sinonimos: '',
        componentesactivos: "",
        componentesactivosIngles: '',
        cas: '',
        estado: null,
        id_fabricante: null,
        uso: '',
        observacion: '',
        disposiciontratamiento: '',
        doc_sga: '',
        doc_etiqueta: '',
        fecha_etiqueta: '',
        tipoproducto: null,
        components: []
    }
}

export const defaultAdjunto = () => {
    return {
        idioma: '',
        tipo: '',
        estado_fds: '',
        sistema: 'no',
        observacion: '',
        avatar: null,
        fecha: '',
        cumple_decreto: '',
        activo: 1,
        no_cumple: 1,
        observacion_no_cumple: ''
    }
}

/**
 * contiene la información para el manejo de SGA.
 */
export const defaultSga = () => {
    return {
        categoriasfisicas: [],
        categoriassalud: [],
        categoriasambiental: [],
        categoriasNpeligrosas: [],
    }
}

export const defaultEpps = () => {
    return {
        layer_ocular: {},
        layer_respiratoria: {},
        layer_ropa: {},
        layer_cutanea: {},
        layer_calzado: {},
    }
}

export const initialDataComponents = () => {
    return [];
}

export default {
    modal: {
        ver: false,
        paso: 0,
        loader: false
    },
    producto: defaultProducto(),
    adjunto: defaultAdjunto(),
    sga: defaultSga(),
    epps: defaultEpps(),
    fisicos: [],
    salud: [],
    ambiental: [],
    peligrosas: [],
    fabricantes: [],
    idiomas: [],
    tipos: [],
    estados_fds: [],
    empresas: [],
    ubicaciones: [],
    tipoProductos: [],
    ubicaciones_seleccionadas: [],
    empresa: {},
    existe: [
        { value: 160, text: "Existe" },
        { value: 161, text: "No existe" }
    ],
    estados: [
        { value: 131, text: "Solido" },
        { value: 132, text: "Liquido" },
        { value: 133, text: "Gaseoso" }
    ],
    // Componentes del producto
    components: initialDataComponents()
}
